// extracted by mini-css-extract-plugin
export default {"title":"_880ef68403","inner_title":"_5b068a4e6e","charge_btn":"_0dca1ddbe9"};